import { PureComponent } from 'react';
import qs from 'qs';
import { withRouter } from 'react-router-dom';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import * as Sentry from '@sentry/react';

// COMPONENTS
import ContactlessLoading from 'views/Contactless/components/Contactless.Loading';

// SELECTORS
import {
  selectLoading,
  selectErrors,
  selectTokenAuthorized,
  selectContactlessToken,
} from 'services/Authentication/selectors';

// THUNKS
import { authenticateContactless, logoutUser } from 'services/Authentication/thunks';

// UTILS
import { intercom } from 'utils';
import { changeLocale } from 'services/Language/actions';

export default function notAuthenticated(Component) {
  class Contactless extends PureComponent {
    state = {
      error: false,
      urlParam: '',
    };

    componentDidMount() {
      // @ts-expect-error TS(2339): Property 'logoutUser' does not exist on type 'Read... Remove this comment to see the full error message
      this.props.logoutUser(false, false);

      const { urlToken } = this.getParamsFromUrl();

      intercom.shutdown();

      Sentry.addBreadcrumb({
        category: 'auth',
        message: `Customer token in Url? ${String(urlToken)}`,
        level: 'info',
      });

      if (urlToken) {
        // @ts-expect-error TS(2339): Property 'authenticateContactless' does not exist ... Remove this comment to see the full error message
        this.props.authenticateContactless(urlToken);
      }
      if (location.search) {
        this.setState({
          urlParam: location.search,
        });
      }
    }

    componentDidUpdate() {
      // Tango down.
      intercom.shutdown(); // ensuring intercom stays off.

      const { language, urlToken } = this.getParamsFromUrl();

      // @ts-expect-error TS(2339): Property 'loading' does not exist on type 'Readonl... Remove this comment to see the full error message
      if (!this.props.location.state?.lang && language) {
        // @ts-expect-error TS(2339): Property 'changeLocale' does not exist on type 'Read... Remove this comment to see the full error message
        this.props.changeLocale(`${language}-CA`);
        // @ts-expect-error TS(2339): Property 'history' does not exist on type 'Readonl... Remove this comment to see the full error message
        this.props.history.replace(
          // @ts-expect-error TS(2339): Property 'history' does not exist on type 'Readonl... Remove this comment to see the full error message
          this.props.location.pathname,
          {
            // @ts-expect-error TS(2339): Property 'history' does not exist on type 'Readonl... Remove this comment to see the full error message
            ...this.props.location.state,
            lang: `${language}-CA`,
          },
          this.state.urlParam
        );
      }

      // @ts-expect-error TS(2339): Property 'authorizedByToken' does not exist on typ... Remove this comment to see the full error message
      if (urlToken && this.props.authorizedByToken) {
        // @ts-expect-error TS(2339): Property 'history' does not exist on type 'Readonl... Remove this comment to see the full error message
        this.props.history.replace(
          // @ts-expect-error TS(2339): Property 'history' does not exist on type 'Readonl... Remove this comment to see the full error message
          this.props.location.pathname,
          {
            // @ts-expect-error TS(2339): Property 'state' does not exist on type 'Readonly<... Remove this comment to see the full error message
            ...this.props.location.state,
            // @ts-expect-error TS(2339): Property 'token' does not exist on type 'Readonly<... Remove this comment to see the full error message
            auth: this.props.token,
          },
          this.state.urlParam
        );
      }
    }

    getParamsFromUrl = () => {
      // @ts-expect-error TS(2339): Property 'location' does not exist on type 'Readon... Remove this comment to see the full error message
      let { token: urlToken, lang: language } = qs.parse(this.props.location.search, {
        ignoreQueryPrefix: true,
      });

      if (typeof urlToken !== 'string' || urlToken.length <= 0) {
        urlToken = '';
      }

      if (typeof language !== 'string' || language.length <= 0) {
        language = 'en';
      }

      return { urlToken, language };
    };

    render() {
      // @ts-expect-error TS(2339): Property 'loading' does not exist on type 'Readonl... Remove this comment to see the full error message
      const { loading, location } = this.props;

      Sentry.addBreadcrumb({
        category: 'auth',
        // @ts-expect-error TS(2339): Property 'authorizedByToken' does not exist on typ... Remove this comment to see the full error message
        message: `Token exhanged? ${String(this.props.authorizedByToken)}`,
        level: 'info',
      });

      // @ts-expect-error TS(2339): Property 'authErrors' does not exist on type 'Read... Remove this comment to see the full error message
      if (!this.props.authErrors.size && (loading || location.search)) {
        return <ContactlessLoading />;
      }

      // @ts-expect-error TS(2339): Property 'dispatch' does not exist on type 'Readon... Remove this comment to see the full error message
      return <Component dispatch={this.props.dispatch} />;
    }
  }

  const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
      {
        authenticateContactless,
        logoutUser,
        changeLocale,
      },
      dispatch
    );

  const mapStateToProps = createStructuredSelector({
    loading: selectLoading(),
    authErrors: selectErrors(),
    authorizedByToken: selectTokenAuthorized(),
    token: selectContactlessToken(),
  });

  // @ts-expect-error TS(2345): Argument of type 'ConnectedComponent<typeof Contac... Remove this comment to see the full error message
  return withRouter(connect(mapStateToProps, mapDispatchToProps)(Contactless));
}
